import React, { Component } from 'react';
import { ApplicationState } from 'store/rootReducer';
import {
  bulkDeleteThunk,
  bulkTagThunk,
  closeTransactionBulkTagModalAction,
  openTransactionBulkTagModalAction,
  openTransactionEditorThunk,
} from 'store/transactions/transactionsActions';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { confirm } from 'components/ui/modal/BlazeConfirmationModal';
import i18n from 'i18n';
import BzmIcon from '../../../../components/icons/BzmIcon';
import ElevioTooltip from '../../../../components/overlays/helpTooltip/TitleHelpTooltip/ElevioTooltip';
import { getSelectedCountTitle } from '../../../../utils/miscUtil';
import TransactionsBulkConfirm from './TransactionsBulkConfirm';
import DropdownButton from '../../../../components/ui/dropdown/DropdownButton';
import AssetBulkTagModal from './AssetBulkTagModal';
import { BlazeDropdownItem } from '../../../../components/ui/dropdown/DropdownButton/DropdownButton';
import ImportFromUrlModal from '../../../../components/importFromUrl/ImportFromUrlModal';
import { showToastNotification } from 'store/ui/toasts/toastsActions';
import { ToastType } from 'store/ui/toasts/toastsTypes';

class TransactionsBulkActionsHeader extends Component<AllProps> {
  state = {
    showConfirmationModal: false,
    showImportFromUrlModal: false,
  };

  showConfirmationDeleteModal = () => {
    if (this.props.selectAllType === 'ALL') {
      this.onDeleteAllClicked(true);
    } else {
      this.onBulkDeleteClicked();
    }
  };

  onBulkDeleteClicked = () => {
    this.setState({
      isModalOpen: true,
    });

    const modalBody = (
      <p>
        {i18n.t('transactions:table.bulkDeleteWarn')}{' '}
        <strong className="text-break">{this.props.totalTransactionsSelected}</strong>{' '}
        {i18n.t('transactions:table.selected')}
        {this.props.totalTransactionsSelected === 1
          ? ` ${i18n.t('transactions:table.txn')}`
          : ` ${i18n.t('transactions:table.txns')}`}
        ?
      </p>
    );
    confirm({
      confirmation: modalBody,
      yesOptionTitle: `${i18n.t('common:actions.delete')}`,
      title: `${i18n.t('transactions:table.deleteTxns')}`,
    })
      .then(() => {
        this.onBulkDeleteConfirmed();
      })
      .catch(() => {
        // User chose "No"
      });
  };

  onDeleteAllClicked = (keepModalOpen: boolean) => {
    this.setState({
      showConfirmationModal: keepModalOpen,
    });
  };

  onBulkDeleteConfirmed = () => {
    this.props.bulkDelete(
      this.props.selectedTransactions,
      this.props.selectAllType ? this.props.selectAllType : undefined,
    );
    this.onDeleteAllClicked(false);
  };

  onBulkTagClicked = () => {
    this.props.openTransactionBulkTagModalAction();
  };

  openImportFromUrlModal = () => {
    this.setState({ showImportFromUrlModal: true });
  };

  closeImportFromUrlModal = () => {
    this.setState({ showImportFromUrlModal: false });
  };

  onImportFromUrlSuccess = (count: number) => {
    this.props.showToastNotification(
      ToastType.Success,
      i18n.t('transactions:table.importFromUrl'),
      i18n.t('transactions:actions.importFromUrlSuccess', { count }),
    );
  };

  createDropdownItems = () => {
    const resultItems: BlazeDropdownItem[] = [];
    resultItems.push({
      content: i18n.t('transactions:table.createNewTxnAsset'),
      fnCallback: () => {
        this.props.openTransactionEditor('HTTP');
      },
    });
    resultItems.push({
      content: i18n.t('transactions:table.createNewMessaging'),
      fnCallback: () => {
        this.props.openTransactionEditor('MESSAGING');
      },
    });
    resultItems.push({
      content: i18n.t('transactions:table.importFromUrl'),
      fnCallback: this.openImportFromUrlModal,
    });
    return resultItems;
  };

  render() {
    const { totalTransactionsSelected, totalTransactions } = this.props;
    const isButtonDisabled = totalTransactionsSelected === 0 || this.props.isPrivateCloudReadOnly;
    const headerText = getSelectedCountTitle(totalTransactions, totalTransactionsSelected);

    return (
      <React.Fragment>
        <ImportFromUrlModal
          show={this.state.showImportFromUrlModal}
          onHide={this.closeImportFromUrlModal}
          onSuccess={this.onImportFromUrlSuccess}
        />
        <AssetBulkTagModal
          isBulkTaggerOpen={this.props.isBulkTaggerOpen}
          selectedAssets={this.props.selectedTransactions}
          selectAllType={this.props.selectAllType}
          closeAssetBulkTagModalAction={this.props.closeTransactionBulkTagModalAction}
          bulkTagThunk={this.props.bulkTagThunk}
        />
        <TransactionsBulkConfirm
          closeModalAction={(keepModalOpen: boolean) => this.onDeleteAllClicked(keepModalOpen)}
          onBulkDeleteConfirmed={this.onBulkDeleteConfirmed}
          showModal={this.state.showConfirmationModal}
        />
        <Row className="align-items-end">
          {' '}
          {/*  TODO Find Attribute */}
          <Col sm={10}>
            <h2 className="mb-3">
              <span className="mr-2" title={`${i18n.t('transactions:table.txnsAllCaps')} ${headerText}`}>
                {i18n.t('transactions:table.txnsAllCaps')} {headerText}
              </span>

              <ElevioTooltip elevioId={'Transactions_heading_help'} id={'TransactionsHelpId'} />

              <button
                id={`qa-blk-transaction-delete`}
                className="btn btn-link btn-no-hover p-0 mx-2"
                title={i18n.t('transactions:table.removeSelectedTxns')}
                onClick={this.showConfirmationDeleteModal}
                disabled={isButtonDisabled}
              >
                <BzmIcon variant={'icon-bzm-delete'} className={'icon-sm'} />
                <span className="sr-only">{i18n.t('transactions:table.removeTxns')}</span>
              </button>
              <button
                id={`qa-blk-transaction-tag`}
                className="btn btn-link btn-no-hover p-0 mx-2"
                title={i18n.t('transactions:table.tagSelectedTxns')}
                onClick={this.onBulkTagClicked}
                disabled={isButtonDisabled}
              >
                <BzmIcon variant={'icon-bzm-tag'} className={'icon-sm'} />
                <span className="sr-only">{i18n.t('transactions:table.tagSelectedTxns')}</span>
              </button>
            </h2>
          </Col>
          <Col sm={2} className="text-sm-right">
            <div className={'float-right d-inline'}>
              <DropdownButton
                disabled={this.props.isPrivateCloudReadOnly}
                dropdownItems={this.createDropdownItems()}
                toggleTooltip={i18n.t('transactions:table.createNewTxn')}
                innerButtonSpanClassName="icon-bzm-add"
                dropdownToggleClassName={`btn btn-primary btn-circular btn-jb `}
              />
            </div>
          </Col>
        </Row>
        <p>{i18n.t('transactions:table.txnsTableDesc')}</p>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => {
  return {
    totalTransactionsSelected: state.transactions.selectedTransactionsCount,
    selectedTransactions: state.transactions.selectedTransactions,
    totalTransactions: state.transactions.totalTransactions,
    isPrivateCloudReadOnly: state.blazeUserConfig.isPrivateCloudReadOnly,
    selectAllType: state.transactions.selectAllType,
    //==
    isBulkTaggerOpen: state.transactions.isBulkTaggerOpen,
  };
};

const mapDispatchToProps = {
  bulkDelete: bulkDeleteThunk,
  openTransactionEditor: openTransactionEditorThunk,
  openTransactionBulkTagModalAction,
  //==
  closeTransactionBulkTagModalAction,
  bulkTagThunk,
  showToastNotification,
};

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type MapDispatchToProps = typeof mapDispatchToProps;

type AllProps = MapStateToProps & MapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(TransactionsBulkActionsHeader);
